import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneSurvayPayload } from '@app-store/slices/survey/oneSurvey'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneSurvayPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.survey.oneSurvey

function* oneSurveySagaTask({ payload }) {
    try {
        const response = yield axios.get(
            `/meeting/survey/one/${payload.surveyId}${
                payload.feedbackQuestionOptionCounts ? `?query={"feedbackQuestionOptionCounts": true}` : ''
            }`
        )
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneSurveySaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneSurveySagaTask)
}

export default oneSurveySaga
